export default {"src":"/_next/static/media/timer.90f82b09.svg","height":44,"width":38,"blurWidth":0,"blurHeight":0};